import hero3 from "src/shared/assets/images/landing/hero3.png";
import { ButtonC } from "src/shared/components";
import { Badge, Col, Row } from "antd";
import HeroStructure from "./heroStructure";
import "./hero3.less";
import { useHistory } from "react-router-dom";
import { useRef } from "react";
const LHero3 = ({ ref }: any) => {
  const { push } = useHistory();

  return (
    <HeroStructure
      sectionProps={{ className: "bg-white hero3" }}
      right={
        <>
          <h3>
            برای پست هایی که آپلود می کنید، <br />
            خودکار لایک و ویو دریافت کنید!
          </h3>
          <p>اتوماسیونی که لایک های و ویوهای شما رو همیشه بالا نگه میداره</p>
          <Col xs={22} xl={16}>
            <Row gutter={[30, 30]} justify="center">
              <Col xs={12} md={12}>
                <ButtonC block onClick={() => push({ hash: "instaLike" })}>
                  <a href="#instaLike">خرید لایک </a>
                </ButtonC>
              </Col>
              <Col xs={12} md={12}>
                <ButtonC block>
                  <a href="#instaView">خرید بازدید</a>
                </ButtonC>
              </Col>
              <Col xs={12} md={12}>
                <ButtonC block onClick={() => push({ hash: "instaComment" })}>
                  <a href="#instaComment"> خرید کامنت</a>
                </ButtonC>
              </Col>
              <Col xs={12} md={12}>
                <ButtonC block onClick={() => push({ hash: "instaFollow" })}>
                  <a href="#instaFollow"> خرید فالوور</a>
                </ButtonC>
              </Col>
            </Row>
          </Col>
        </>
      }
      left={<img src={hero3} />}
      imageLocation="left"
    />
  );
};

export default LHero3;
